/**
 * Definições canônicas de categorias de status — espelha backend/categorization.py
 */
import {
  CheckCircle2,
  Truck,
  RotateCcw,
  AlertTriangle,
  Circle,
} from "lucide-react";

export const CATEGORIAS = [
  {
    key: "entregue",
    label: "Entregue",
    color: "#10B981",
    bg: "bg-emerald-50",
    text: "text-emerald-700",
    border: "border-emerald-200",
    icon: CheckCircle2,
  },
  {
    key: "em_transito",
    label: "Em trânsito",
    color: "#3B82F6",
    bg: "bg-blue-50",
    text: "text-blue-700",
    border: "border-blue-200",
    icon: Truck,
  },
  {
    key: "devolucao",
    label: "Devolução",
    color: "#F59E0B",
    bg: "bg-amber-50",
    text: "text-amber-700",
    border: "border-amber-200",
    icon: RotateCcw,
  },
  {
    key: "problema",
    label: "Problema",
    color: "#F43F5E",
    bg: "bg-rose-50",
    text: "text-rose-700",
    border: "border-rose-200",
    icon: AlertTriangle,
  },
  {
    key: "outros",
    label: "Outros",
    color: "#52525B",
    bg: "bg-zinc-100",
    text: "text-zinc-700",
    border: "border-zinc-200",
    icon: Circle,
  },
];

export const getCategoria = (key) =>
  CATEGORIAS.find((c) => c.key === key) || CATEGORIAS[4];

/**
 * Classifica no frontend (mesma lógica do backend).
 * Ordem: NEGAÇÃO_ENTREGA → problema, depois ENTREGUE > DEVOLUCAO > PROBLEMA > TRANSITO.
 */
export const classifyLocal = (codigo, descricao) => {
  const desc = (descricao || "").toUpperCase();
  const code = (codigo || "").trim();

  // 0) Negação vira problema
  if (/N[AÃ]O\s+(ENTREG|REALIZA|RECEB|FOI)/.test(desc)) return "problema";

  // 1) Entregue
  if (
    /ENTREGA REALIZADA|MERCADORIA ENTREGUE|NF\s+ENTREGUE|BAIXAD[OA].{0,40}ENTREGUE|ENTREGUE EM\b|ENTREGUE CONFORME|ENTREGUE NO|ENTREGUE AO|ENTREGA EFETUAD|ENTREGA CONCLU[IÍ]D|\bENTREGUE\b/.test(
      desc
    )
  )
    return "entregue";

  // 2) Devolução
  if (/DEVOLU|RETORNO\s+AO|REENVI/.test(desc) || code === "15") return "devolucao";

  // 3) Problema
  if (
    /AVARIA|EXTRAVIO|ROUBO|SINISTRO|RASUR|N[AÃ]O\s+LOCALIZAD|AUSENTE|FECHAD|RECUSAD|RECUSA\b|ALEGA\s+SEM\s+SALDO|SEM\s+AGENDAMENTO|FALTA\s+DE\s+PAGAMENTO|N[AÃ]O\s+IA\s+RECEB|N[AÃ]O\s+RECEB|ENDERE[CÇ]O\s+ERRAD|CLIENTE\s+N[AÃ]O/.test(
      desc
    ) ||
    ["04", "05", "06", "08", "09", "10", "11", "26"].includes(code)
  )
    return "problema";

  // 4) Em trânsito
  if (
    /EM\s+ROTA|ROTA\s+DE\s+ENTREGA|EMBARC|CHEGADA|TR[AÂ]NSITO|TRANSITO|TRANSFER[EÊ]NCIA|TRANSPORTE\s+INICIADO|PROCESSO\s+DE\s+TRANSP|CT-E|\bCTE\b|COLETAD|RETIRAD|ENTREGA\s+AGENDAD|EM\s+PROCESSO\s+DE\s+ENTREGA|AGUARDANDO\s+RETIRADA|SA[IÍ]DA\s+DO\s+MOTORISTA|EM\s+VIAGEM|EM\s+DESCARGA/.test(
      desc
    ) ||
    ["14", "44", "59", "82", "98"].includes(code)
  )
    return "em_transito";

  return "outros";
};
